import {
    get as _get,
    isEmpty as _isEmpty,
    filter as _filter,
    flatMap as _flatMap,
    map as _map,
} from 'lodash';

const getCustomFontsArray = (customFonts) => _flatMap(customFonts, ({ fonts }) => _filter(_map(fonts), ['isAuxiliary', false])).map((font) => {
    const { fontID, displayName, unixName, windowsName, fallbackOne, fallbackTwo } = font;
    return {
        fontID,
        value: `'${windowsName}', '${unixName}', '${fallbackOne}', '${fallbackTwo}'`,
        label: displayName,
    };
});

/*
 * We are using the Singleton pattern in order to avoid unnecessary operations
 * since the fonts are going to be the same for the whole user session.
 */
export default class CustomFonts {
    static instance = null;

    constructor(customFonts) {
        if (!CustomFonts.instance && !_isEmpty(customFonts)) {
            CustomFonts.instance = this;

            this.data = getCustomFontsArray(customFonts);
        }

        return _get(CustomFonts, 'instance.data', []);
    }
}
